import { Instagram } from "lucide-react";

const images = [
  {
    src: "https://customer-assets.emergentagent.com/job_amber-auckland/artifacts/pkwvxkt9_image.png",
    alt: "Microneedling pen treatment",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_amber-auckland/artifacts/3td190ik_rwewerrewwre.jpg",
    alt: "LED light therapy",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_amber-auckland/artifacts/r979w8oh_image.png",
    alt: "Skincare flatlay",
  },
  {
    src: "https://plus.unsplash.com/premium_photo-1661671946053-c1472feae11b?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    alt: "Post-treatment cleansing",
  },
  {
    src: "https://images.unsplash.com/photo-1664549761426-6a1cb1032854?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxmYWNpYWwlMjBtYXNzYWdlJTIwc3BhJTIwd29tYW58ZW58MHx8fHwxNzc3Njg5OTYzfDA&ixlib=rb-4.1.0&q=85",
    alt: "Esthetician hands at work",
  },
];

// Asymmetric arrangement: tall hero on left, two stacked on right, then offset row
export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative bg-[#FAEDE6] py-24 md:py-36"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <div>
            <div className="flex items-center gap-4 mb-6">
              <span className="h-px w-8 bg-[#B78782]" />
              <span className="text-[11px] tracking-[0.4em] uppercase text-[#B78782]">
                Inside the Studio
              </span>
            </div>
            <h2 className="font-serif-display text-[#4A3737] text-4xl md:text-5xl lg:text-[58px] font-light leading-[1.05] tracking-tight max-w-xl">
              Quiet moments,
              <br />
              <em className="not-italic font-script text-[#B78782] text-5xl md:text-6xl lg:text-[64px]">
                glowing results.
              </em>
            </h2>
          </div>
          <a
            href="https://www.instagram.com/ambers_mobilebeauty"
            target="_blank"
            rel="noreferrer"
            data-testid="gallery-instagram-link"
            className="inline-flex items-center gap-3 text-[12px] tracking-[0.28em] uppercase border border-[#B78782] text-[#4A3737] px-6 py-3.5 hover:bg-[#B78782] hover:text-[#FAEDE6] transition-colors duration-300 self-start md:self-end"
          >
            <Instagram size={16} strokeWidth={1.5} />
            @ambers_mobilebeauty
          </a>
        </div>

        {/* Asymmetric layout */}
        <div className="grid grid-cols-12 gap-3 md:gap-4">
          {/* Tall hero left */}
          <figure
            data-testid="gallery-item-0"
            className="col-span-12 md:col-span-5 row-span-2 group overflow-hidden"
          >
            <div className="aspect-[4/5] md:aspect-auto md:h-full overflow-hidden">
              <img
                src={images[0].src}
                alt={images[0].alt}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.04]"
              />
            </div>
          </figure>

          {/* Top right wide */}
          <figure
            data-testid="gallery-item-1"
            className="col-span-12 md:col-span-7 group overflow-hidden"
          >
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src={images[1].src}
                alt={images[1].alt}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.04]"
              />
            </div>
          </figure>

          {/* Bottom right pair */}
          <figure
            data-testid="gallery-item-2"
            className="col-span-6 md:col-span-3 md:col-start-6 group overflow-hidden"
          >
            <div className="aspect-square overflow-hidden">
              <img
                src={images[2].src}
                alt={images[2].alt}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.04]"
              />
            </div>
          </figure>

          <figure
            data-testid="gallery-item-3"
            className="col-span-6 md:col-span-4 group overflow-hidden"
          >
            <div className="aspect-square overflow-hidden">
              <img
                src={images[3].src}
                alt={images[3].alt}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.04]"
              />
            </div>
          </figure>

          {/* Bottom full-width strip, offset right */}
          <figure
            data-testid="gallery-item-4"
            className="col-span-12 md:col-span-8 md:col-start-3 group overflow-hidden mt-2 md:mt-4"
          >
            <div className="aspect-[21/9] overflow-hidden">
              <img
                src={images[4].src}
                alt={images[4].alt}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.04]"
              />
            </div>
          </figure>
        </div>
      </div>
    </section>
  );
}
